import React, { useState } from "react";
import "./PuttingSplitsTable.css";
import { graphql, useLazyLoadQuery } from "react-relay";
import StatTable from "../../../../../../StatTable";
import DraftkingsInfoOverlay from "../../../../../../DraftKingsInfoOverlay";

const QUERY = graphql`
  query PuttingSplitsTableQuery($eventId: ID!, $grassCategoryIds: [ID]!) {
    whoAmI {
      username
    }

    pgaPuttingSplitsOverview(
      eventId: $eventId
      grassCategories: $grassCategoryIds
    ) {
      player {
        id
        fullName
        dkPlayer {
          id
          playerDkId
        }
      }

      numRounds
      strokesGainedPutting
      putt0612FtPct
      putt1218FtPct
      puttsPerHole
    }
  }
`;

export default function PuttingSplitsTable({ eventId, grassCategoryId }) {
  if (!grassCategoryId) {
    return;
  }

  const queryData = useLazyLoadQuery(
    QUERY,
    {
      eventId: eventId,
      grassCategoryIds: [grassCategoryId],
    },
    {
      fetchPolicy: "network-only",
    }
  );

  const [selectedDkPlayerId, setSelectedDkPlayerId] = useState(undefined);

  function showDKPlayerInfo(dkPlayerId) {
    if (dkPlayerId) {
      setSelectedDkPlayerId(dkPlayerId);
    }
  }

  const columns = [
    {
      Header: "Name",
      accessor: "player",
    },
    { Header: "Num Rounds", accessor: "numRounds" },
    {
      Header: "SG: PUTT",
      accessor: "strokesGainedPutting",
    },
    { Header: "6-12ft", accessor: "putt0612FtPct" },
    { Header: "12-18ft", accessor: "putt1218FtPct" },
    { Header: "Avg Putts Per Hole", accessor: "puttsPerHole" },
  ];

  const data = queryData.pgaPuttingSplitsOverview.map((entry) => {
    const newEntry = { ...entry };

    newEntry.player = entry.player.fullName;

    if (entry.player.dkPlayer) {
      newEntry.dkPlayerId = entry.player.dkPlayer.id;
    }

    // TODO: Figure out why num rounds can be 0 but stats are populated
    if (entry.numRounds === 0) {
      newEntry.strokesGainedPutting = undefined;
      newEntry.putt0612FtPct = undefined;
      newEntry.putt1218FtPct = undefined;
      newEntry.puttsPerHole = undefined;
    }

    return newEntry;
  });

  return (
    <>
      <DraftkingsInfoOverlay
        show={selectedDkPlayerId !== undefined}
        playerId={selectedDkPlayerId}
        close={() => setSelectedDkPlayerId(undefined)}
      />
      <StatTable
        data={data}
        columns={columns}
        showDKPlayerInfo={showDKPlayerInfo}
      />
    </>
  );
}
